import axios from 'axios';

 export const HttpClientHandler = axios.create({    
     baseURL: process.env.REACT_APP_API_URL         
 })